import LoadMore from "components/common/LoadMore";
import { LayoutGroup, motion } from "framer-motion";
import { useModalScrollbar } from "hooks/useFreeze";
import { useRouter } from "next/router";
import { useCallback, useEffect, useState } from "react";
import { projects } from "store/allData";
import Filters from "../Filters";
import EachProject from "./EachProject";
import ProjectModal from "./ProjectModal";
import _values from "lodash/values";
import { badgeType, projectType } from "types/allTypes";
import Heading from "components/common/Heading";
import SectionWrapper from "components/common/SectionWrapper";

const projectTypeArray: badgeType[] = _values(projects);

interface props {
  shuffledProjects: projectType[];
}

const Projects: React.FC<props> = ({ shuffledProjects }) => {
  const router = useRouter();
  const [num, setNum] = useState(6);
  const [isOpen, setIsOpen] = useState(false);
  useModalScrollbar(isOpen);
  const [typeFilter, setTypeFilter] = useState("All");

  useEffect(() => {
    if (!!router.query.project) {
      setIsOpen(true);
    }
  }, [router.query.project]);

  const activeProjectsData = shuffledProjects
    .filter((item) => true)
    .sort((a, b) => {
      if (typeFilter === "" || typeFilter === "All") return 0;
      let isFiltered = false;
      a.type.forEach((item) => {
        if (item.name === typeFilter) {
          isFiltered = true;
        }
      });
      return isFiltered ? -1 : 1;
    });

  const filterClickHandler = useCallback((data: badgeType) => {
    setNum(activeProjectsData.length);
    setTypeFilter(data.name);
  }, []);

  return (
    <div
      id="projects"
      className="w-full mx-auto flex flex-col justify-start items-center pt-16 pb-28 relative scroll-mt-32"
    >
      <SectionWrapper className="mx-auto flex flex-col justify-start items-center relative">
        <span className="eyebrow">Selected work</span>
        <Heading className="text-3xl sm:text-4xl mt-4 mb-4 text-center">
          Our projects
        </Heading>
        <p className="max-w-xl text-center text-zinc-400 mb-8">
          Real products in production — from DeFi platforms and prediction
          markets to SaaS tools and brand identities.
        </p>
        <div className="w-11/12 md:w-2/3">
          <Filters
            typeFilter={typeFilter}
            filterClickHandler={filterClickHandler}
            projectTypeArray={projectTypeArray}
          />
        </div>
        <LayoutGroup>
          <motion.ul
            className="w-11/12 ssm:w-9/12 sm:w-11/12 md:w-10/12 lg:w-11/12 xl:w-10/12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3
          justify-center gap-5 auto-rows-fr p-5 mt-5"
          >
            {activeProjectsData.map((data, index) => {
              if (index + 1 > num) return null;

              return <EachProject key={data.id} data={data} index={index} />;
            })}
          </motion.ul>
          <ProjectModal setIsOpen={setIsOpen} isOpen={isOpen} />
        </LayoutGroup>
        <LoadMore
          className="absolute bottom-[-80px] z-100 "
          initial={6}
          addPerClick={6}
          num={num}
          fullLength={activeProjectsData.length}
          setNum={setNum}
        />
      </SectionWrapper>
    </div>
  );
};

export default Projects;
